// extracted by mini-css-extract-plugin
module.exports = {"button":"expandable-container-module__button___IAE7J","icon":"expandable-container-module__icon___1LJWu","content":"expandable-container-module__content___1GXAL"};